import type { ImageLoaderProps } from 'next/image';

/**
 * Maps a source photograph to the pre-built variant for a given width, so that
 * `next/image` can emit a real `srcset` on a static export with no image server.
 * scripts/build-images.mjs writes the variants; the widths it builds are
 * `images.deviceSizes` in next.config.ts.
 *
 * Anything that is not a photograph (the SVG badge in the footer) is returned
 * untouched. JPEG and PNG sources both become WebP variants.
 */
export default function imageLoader({ src, width }: ImageLoaderProps): string {
  if (!/\.(jpe?g|png)$/i.test(src)) return src;
  return src.replace(/\.(jpe?g|png)$/i, `-${width}.webp`);
}
